import { personName } from '@unit/shared';

/**
 * A person's name with the rank *beside* it, muted, never inside it (owner,
 * 2026-09-19, story 38): a search or sort on the name is then a search on
 * the name. Lists and pickers use this; a table gives the rank its own
 * column instead.
 */
export function PersonName({ person }: { person: { firstName: string; lastName: string; rank: string | null } }) {
  return (
    <>
      <span data-testid="person-name">{personName(person)}</span>
      {person.rank && (
        <span className="ms-1.5 text-xs text-slate-500" data-testid="person-rank">
          {person.rank}
        </span>
      )}
    </>
  );
}
